module.exports = __webpack_public_path__ + "img/clipboard-check.c32121f9.svg";